import { useCallback, useContext, useMemo } from 'react';
import { LocaleContext } from './LocaleProvider';
export function useLocale(componentName) {
    const { localesByLang, lang } = useContext(LocaleContext);
    const locales = useMemo(() => {
        if (!componentName) {
            return localesByLang;
        }
        return (localesByLang[componentName] || {});
    }, [componentName, localesByLang]);
    const getLocaleText = useCallback(key => {
        let translation = '';
        const complexKey = key.split('.');
        if (complexKey.length === 1) {
            translation = locales[key];
        }
        else {
            translation = complexKey.reduce((acc, cur) => acc[cur], locales);
        }
        if (!(translation === null || translation === void 0 ? void 0 : translation.length)) {
            console.warn(`Snack-uikit: the '${key}' key is not found in the current locale '${lang}'.`);
            return key;
        }
        return translation;
    }, [lang, locales]);
    return {
        t: getLocaleText,
        lang,
    };
}
